import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useSelector } from "react-redux";
import CopyIcon from "../../../assets/icons/copy-blue.svg";
import ProfileIcon from "../../../assets/newIcons/profileIcon.svg";
import "./style.scss";
import { toast, ToastContainer } from "react-toastify";
function AccountDetails() {
  // const [copyToClipboard, setCopyToClipboard] = useState({
  //   value: "",
  //   copied: false,
  // });
  const accountsData = useSelector((state) => state.account.accountMetrics);
  const selectedBrand = useSelector((state) => state.brand.selectedBrand);

  const userDetails = useSelector((state) => state.user);
  const [Ametrics, setAmetrics] = useState([]);

  useEffect(() => {
    setAmetrics(accountsData?.data || []);
  }, [accountsData]);

  const [eye, setEye] = useState(false);
  const [eye2, setEye2] = useState(false);
  const [, setTooltipOpen1] = useState(false);
  const [, setIsLoginCopy] = useState(false);
  const [, setTooltipOpen2] = useState(false);

  const { challenge_type } = useSelector((state) => state.account.accountMetrics.data);

  const handleCopyToClipboard = (text) => {
    if (text !== "") {
      toast(text ? "Text Copied to clipboard !" : "NA", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: "success",
        theme: "dark",
        className: "custom-toast-container",
      });
    }
  };

  // derive plan and flagship step info
  const planName = accountsData?.data?.plan_name || "";
  const isFlagship = challenge_type === "flagship" || /flagship/i.test(planName);
  const isTwoStepFlagship = isFlagship && /2\s*step/i.test(planName);

  return (
    <div className="accountdetails-container">
      <ToastContainer />
      <div className="accountdetails-subcontainer">
        <img
          src={ProfileIcon}
          alt="profile icon"
          className="accountdetails-image_dp"
        />
        <div className="accountdetails-innercontainer">
          <h4>{userDetails.first_name + " " + userDetails.last_name}</h4>
          <div className="accntMoreInfo">
            <p>{accountsData.data?.login_id}</p>

            <CopyToClipboard
              onCopy={handleCopyToClipboard}
              text={accountsData.data?.login_id}
            >
              <div>
                <img
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setIsLoginCopy(true);
                    // handleCopyClick1();
                  }}
                  src={CopyIcon}
                  alt="copy"
                />
              </div>
            </CopyToClipboard>
          </div>
          <p>{accountsData.data?.phase?.replace("_", " ")}</p>
        </div>
      </div>
      <div className="accountdetails-container_details">
        <div className="accountdetails-groupA">
          {selectedBrand?.brand === "crypto_edge" && (
            <>
              {" "}
              <div>
                <h5>Leverage(BTC/ETH)</h5>
                <p className="accountdetails-profit">1:3</p>
              </div>
              <div>
                <h5>Leverage(ALT Coin)</h5>
                <p className="accountdetails-profit">1:2</p>
              </div>
            </>
          )}

          {(challenge_type === "pro_edge" || challenge_type === "Instant") && selectedBrand?.brand === "equity_edge" && (
            <>
              <div>
                <h5>(Fx) Leverage </h5>
                <p className="accountdetails-profit">1:30</p>
              </div>
              <div>
                <h5>(Indices) Leverage </h5>
                <p className="accountdetails-profit">1:10</p>
              </div>
              <div>
                <h5>(Metals) Leverage </h5>
                <p className="accountdetails-profit">1:10</p>
              </div>
              <div>
                <h5>(Oil) Leverage </h5>
                <p className="accountdetails-profit">1:10</p>
              </div>
              <div>
                <h5>(Crypto) Leverage </h5>
                <p className="accountdetails-profit">1:2</p>
              </div>
            </>
          )}

          {isFlagship && selectedBrand?.brand === "equity_edge" && (
            <>
              <div>
                <h5>(Fx) Leverage </h5>
                <p className="accountdetails-profit">{isTwoStepFlagship ? "1:100" : "1:50"}</p>
              </div>
              <div>
                <h5>(Indices) Leverage </h5>
                <p className="accountdetails-profit">{isTwoStepFlagship ? "1:20" : "1:10"}</p>
              </div>
              <div>
                <h5>(Metals) Leverage </h5>
                <p className="accountdetails-profit">{isTwoStepFlagship ? "1:30" : "1:10"}</p>
              </div>
              <div>
                <h5>(Oil) Leverage </h5>
                <p className="accountdetails-profit">1:10</p>
              </div>
              <div>
                <h5>(Crypto) Leverage </h5>
                <p className="accountdetails-profit">1:2</p>
              </div>
            </>
          )}

          {!isFlagship && selectedBrand?.brand === "equity_edge" && challenge_type !== "pro_edge" && challenge_type !== "Instant" && (
            <>
              <div>
                <h5>(Fx) Leverage </h5>
                <p className="accountdetails-profit">
                  {/EE\s*Challenge/i.test(planName) ? "1:40" : /1\s*step\s*legacy/i.test(planName) ? "1:40" : /2\s*step\s*legacy/i.test(planName) ? "1:40" : /1\s*step\s*swift/i.test(planName) ? "1:30" : /2\s*step\s*swift/i.test(planName) ? "1:30" : "1:100"}
                </p>
              </div>
              <div>
                <h5>(Indices) Leverage </h5>
                <p className="accountdetails-profit">
                  {(/2\s*step\s*legacy/i.test(planName) || (/2\s*step/i.test(planName) && /EE\s*Challenge/i.test(planName))) ? "1:15" : "1:10"}
                </p>
              </div>
              <div>
                <h5>(Metals) Leverage </h5>
                <p className="accountdetails-profit">
                  {(/2\s*step\s*legacy/i.test(planName) || (/2\s*step/i.test(planName) && /EE\s*Challenge/i.test(planName))) ? "1:15" : "1:10"}
                </p>
              </div>
              <div>
                <h5>(Oil) Leverage </h5>
                <p className="accountdetails-profit">1:10</p>
              </div>
              <div>
                <h5>(Crypto) Leverage </h5>
                <p className="accountdetails-profit">1:2</p>
              </div>
            </>
          )}
          <div>
            <h5>Challenge</h5>
            <p>{accountsData.data?.challenge}</p>
          </div>

          {selectedBrand?.brand === "equity_edge" && (
            <div>
              <h5>Broker</h5>
              {/* <p>{Ametrics.server}</p> */}
              <p>{accountsData?.data?.trading_platform?.toUpperCase() === "MT5" ? "Equity Edge LTD" : accountsData?.data?.server}</p>
            </div>
          )}
        </div>
        <div className="accountdetails-groupB">
          <div>
            <h5>Investor password</h5>
            <div
              style={{ position: "relative", display: "flex", gap: "10px", width: "fit-content", flexDirection: "row", alignItems: "center" }}
              className="role-p"
            >
              <div className="password_main">{eye ? Ametrics?.investor_password || "NA" : "*********"}</div>
              <div
                style={{ cursor: "pointer", display: "flex" }}
                onClick={() => setEye(!eye)}
              >
                {eye ? <RemoveRedEyeIcon /> : <VisibilityOffIcon />}
              </div>
              <div>
                <CopyToClipboard
                  onCopy={eye && handleCopyToClipboard}
                  text={Ametrics?.investor_password}
                >
                  <div>
                    <img
                      style={{ cursor: eye ? "pointer" : "not-allowed", display: "flex" }}
                      onClick={() => {
                        setTooltipOpen1(true);
                        // handleCopyClick1();
                      }}
                      src={CopyIcon}
                      alt="copy"
                    />
                  </div>
                </CopyToClipboard>
              </div>
            </div>
          </div>

          <div>
            <h5>Master password </h5>
            <div
              style={{ position: "relative", display: "flex", gap: "10px", width: "fit-content", flexDirection: "row", alignItems: "center" }}
              className="role-p"
            >
              <div className="password_main">{eye2 ? Ametrics?.password : "*********"}</div>
              <div
                style={{ cursor: "pointer", display: "flex" }}
                onClick={() => setEye2(!eye2)}
              >
                {eye2 ? <RemoveRedEyeIcon /> : <VisibilityOffIcon />}
              </div>
              <div>
                <CopyToClipboard
                  onCopy={eye2 && handleCopyToClipboard}
                  text={Ametrics?.password}
                >
                  <div>
                    <img
                      style={{ cursor: eye2 ? "pointer" : "not-allowed", display: "flex" }}
                      onClick={() => setTooltipOpen2(true)}
                      src={CopyIcon}
                      alt="copy"
                    />
                  </div>
                </CopyToClipboard>
              </div>
            </div>
          </div>
          <div>
            <h5>Starting balance </h5>
            <p>$ {Ametrics?.starting_balance?.toLocaleString("en-US")}</p>
          </div>
          <div>
            <h5>Account start date</h5>
            <p>{moment(Ametrics.start_date).format("ll")}</p>
          </div>
        </div>
      </div>
    </div>
    // </div>
  );
}

export default AccountDetails;
